<template>
  <div class="notices">
    <h4>NEWS&NOTICES</h4>
    <ul class="list">
      <li @click="jump('/sub_notice2')">
        <img class="img" src="@/assets/img/img1.png" alt="">
        <h5>NOTICE OF OFFICE RELOCATION</h5>
        <p>Dear Valued Clients and Partners<br>
        NOTICE OF OFFICE RELOCATION<br>
        We are pleased to inform you that our office will…</p>
        <img class="icon" src="@/assets/img/arrow.png" alt="">
      </li>
      <li @click="jump('/sub_notice1')">
        <img class="img" src="@/assets/img/img2.png" alt="">
        <h5>Scam Alert</h5>
        <p>1.Do not disclose your  OTP/ PIN or password to anyone. Okash/EM will never request for your OTP/Pin or Password…</p>
        <img class="icon" src="@/assets/img/arrow.png" alt="">
      </li>
      <li @click="jump('/sub_notice3')">
        <img class="img" src="@/assets/img/img3.png" alt="">
        <h5>HELP CENTER </h5>
        <p>"Borrow a loan in 3 simple steps:<br>1. Apply for loan Open the EaseMoni App, click on 'Apply now', complete registration, take a selfie and link your bank account for loan disbursement.</p>
        <img class="icon" src="@/assets/img/arrow.png" alt="">
      </li>
    </ul>
  </div>
</template>

<script>
import router from '@/router/index'
export default {
  methods: {
    jump(url) {
      console.log(url, this, 'this.$router.push')
      router.push(url)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/public.scss';

.notices {
  width: 100%;
  padding: 72px 120px 55px;
  background: linear-gradient(0deg, #4296FE 0%, #4296FE 100%), #326CBE;
  h4 {
    color: #fff;
    font-size: 44px;
    font-weight: 600;
    line-height: 86px;
    text-align: center;
  }
  .list {
    margin-top: 30px;
    @include flex-base;
    li {
      flex: 1;
      cursor: pointer;
      margin-right: 33px;
      &:last-child {
        margin: 0;
      }
      .img {
        width: 100%;
        height: 200px;
      }
      h5 {
        margin: 32px 0 16px;
        color: #fff;
        font-size: 22px;
        font-weight: 500;
        line-height: 40px;
      }
      p {
        color: #fff;
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .icon {
        margin: 8px 169px 0;
        width: 40px;
        height: 40px;
      }
    }
  }
}
  
</style>